<template>
  <div class="hidden-print exp-0225-cs-consult-banner">
    <div class="cs-consult-header">
      <h4 class="cs-consult-title">{{ headline }}</h4>

      <p class="cs-consult-description">
        Your Customer Success Manager can help you interpret these and get the most out of monitoring your team.
      </p>
    </div>

    <hr class="cs-consult-divider" />

    <div class="cs-consult-footer">
      <div class="csm-identity">
        <img
          :src="csmAvatar"
          alt=""
          class="csm-avatar"
          width="32"
          height="32"
        />

        <div>
          <div class="csm-name">{{ csmName }}</div>
          <div class="csm-role">Your Customer Success Manager</div>
        </div>
      </div>

      <a
        :href="banner.call_link"
        class="cs-consult-cta"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="cs-consult-schedule-call"
        @click="trackCtaClick"
      >
        <i class="hi hi-20 hi-calendar"></i>
        <span>Schedule a call</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AR0225_CSM_AVATAR } from '~/rails_assets';
import { AnalyticsResource } from '~/resources';
import { pluralize } from '~/utils/string_utils';

const CSM_NAME = 'Bruno Ribas';
const CTA_CLICKED_EVENT = '0225 In App Unusual Activity CSM Consult CTA Clicked';
const CTA_EVENT_SOURCE = 'unusual_activity_page_cs_consult';

export default {
  name: 'InsightsUnusualActivityConsultBanner',
  props: {
    banner: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    csmAvatar: AR0225_CSM_AVATAR,
    csmName: CSM_NAME,
  }),
  computed: {
    ...mapGetters(['organizationId']),
    headline() {
      const { instances, members } = this.banner;

      return `We noticed ${instances} unusual activity ${pluralize(instances, 'instance')} across ${members} ${pluralize(members, 'member')} in the last 30 days`;
    },
  },
  methods: {
    trackCtaClick() {
      AnalyticsResource.create(null, {
        event_name: CTA_CLICKED_EVENT,
        event_properties: {
          organization_id: this.organizationId,
          source: CTA_EVENT_SOURCE,
          user_role: this.banner.user_role,
        },
      });
    },
  },
};
</script>
